module.exports = __webpack_public_path__ + "img/blog-7.9af70859.webp";